import View from './SocialNetworkList'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const SocialNetworkList = connect(mapStateToProps)(View)

export default SocialNetworkList
